
import { UseQuestionsListProps, UseQuestionsListResult } from './types';
import { useQuestionState } from './useQuestionState';
import { useQuestionHandlers } from './questionHandlers';

export function useQuestionsList({ 
  categories, 
  setCategories,
  assessment,
  onContentChange
}: UseQuestionsListProps): UseQuestionsListResult {
  const {
    selectedCategoryId,
    setSelectedCategoryId,
    isAddingQuestion,
    setIsAddingQuestion,
    editingQuestionId,
    setEditingQuestionId,
    selectedCategory
  } = useQuestionState(categories);

  const {
    handleAddQuestion,
    handleEditQuestion,
    handleCloseQuestionForm,
    handleSaveQuestion,
    handleDeleteQuestion,
    handleToggleQuestionStatus,
    handleDragEnd,
    handleUpdateQuestion,
    handleUpdateAnswer,
    handleAddAnswer
  } = useQuestionHandlers({
    categories,
    setCategories,
    selectedCategory,
    setIsAddingQuestion,
    setEditingQuestionId,
    onContentChange
  });

  // Check if this is a maturity model assessment
  const isMaturityModel = assessment?.isMaturityModel || false;

  return {
    selectedCategoryId,
    setSelectedCategoryId,
    selectedCategory,
    isAddingQuestion,
    editingQuestionId,
    handleAddQuestion,
    handleEditQuestion,
    handleCloseQuestionForm,
    handleSaveQuestion,
    handleDeleteQuestion,
    handleToggleQuestionStatus,
    isMaturityModel,
    handleDragEnd,
    handleUpdateQuestion,
    handleUpdateAnswer,
    handleAddAnswer
  };
}
